import { createApi } from "@reduxjs/toolkit/query/react";

import apiBaseQuery from "./axiosBaseQuery";

export const COMMENT_API_REDUCER_KEY = "commentsApi";

export const commentsApi = createApi({
  reducerPath: COMMENT_API_REDUCER_KEY,
  baseQuery: apiBaseQuery,
  tagTypes: ["comment"],
  endpoints: (builder) => ({
    getCommentList: builder.query({
      query: ({ task, page, limit }) => {
        if (!task) {
          return;
        }
        return {
          url: `tasks/task_comments?task=${task}&page=${page || 1}&limit=${
            limit || 10
          }`,
        };
      },
      providesTags: ["comment"],
    }),

    getComment: builder.query({
      query: (id) => {
        if (!id) {
          return;
        }
        return {
          url: `tasks/task_comments/${id}/`,
        };
      },
      providesTags: ["comment"],
    }),

    createComment: builder.mutation({
      query: (body) => ({
        url: `tasks/task_comments/`,
        method: "POST",
        body,
      }),
      invalidatesTags: ["comment"],
    }),
    updateComment: builder.mutation({
      query: ({ id, ...rest }) => ({
        url: `tasks/task_comments/${id}/`,
        method: "PUT",
        body: rest,
      }),
      invalidatesTags: ["comment"],
    }),

    deleteComment: builder.mutation({
      query: (id) => ({
        url: `tasks/task_comments/${id}/`,
        method: "DELETE",
      }),
      invalidatesTags: ["comment"],
    }),
  }),
});

export const {
  useCreateCommentMutation,
  useDeleteCommentMutation,
  useGetCommentQuery,
  useGetCommentListQuery,
  useUpdateCommentMutation,
} = commentsApi;
